<template>
  <el-table-column
    prop="docket_book.name"
    label="Iktatókönyv"
    sortable="custom"
    show-overflow-tooltip
    min-width="160"
  >
    <template slot-scope="scope">
      {{ scope.row.docket_book && scope.row.docket_book.name }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'docket_book.name',
  };
</script>
